module.exports = __webpack_public_path__ + "media/images/icons/country_flags/to-a7375d4d2ef32a2c8761849cac54fa64.svg";